import {
  IEmailModel,
  ParentRelationEnum,
} from 'Modules/Communication/Email/shared/models/Email'
import {
  IEmailMessage,
  SendEmailFieldName,
  SendMessagePatchBody,
} from 'shared/models/Message'

export const getDraftPatchBody = ({
  field,
  value,
}: {
  field: SendEmailFieldName
  value: string
}): SendMessagePatchBody[] => {
  value = value?.trim()
    ? field === 'contentHtml'
      ? getWrappedEmailContent(value)
      : value
    : ''

  return [
    {
      op: 'replace',
      path: '/' + field,
      value,
    },
  ]
}

// Compare changes between messages, and get patch body for differences
export const getPatchBodyForAllChanges = (
  messageFromForm: IEmailMessage,
  messageInStore?: IEmailModel
): SendMessagePatchBody[] => {
  const returnBody: SendMessagePatchBody[] = []
  if (messageInStore?.contentHtml !== messageFromForm.contentHtml)
    returnBody.push({
      op: 'replace',
      path: '/contentHtml',
      value: getWrappedEmailContent(messageFromForm.contentHtml),
    })

  if (messageInStore?.title !== messageFromForm.title)
    returnBody.push({
      op: 'replace',
      path: '/title',
      value: messageFromForm.title,
    })
  return returnBody
}

export const getWrappedEmailContent = (html: string) => {
  return html.includes('<html>')
    ? html
    : `<html>
  <head>
  <style>
  body {font-family:'Source Sans 3',sans-serif; font-size:16px; }
  p {margin: 0;}
  h1,h2,h3,h4,h5,h6 {margin-top: 0; margin-bottom: 0;}
  .standard-signature,.signature {line-height: 23px;}
  </style>
  </head>
  <body>${html}</body>
  </html>`
}

export const getEmailModalTitle = (
  relation?: ParentRelationEnum | null,
  title?: string
) => {
  const strippedTitle = title?.split(':')[1] || ''
  switch (relation) {
    case ParentRelationEnum.forward:
      return 'Videresend: ' + (strippedTitle || '')
    case ParentRelationEnum.reply:
      return 'Svar: ' + (strippedTitle || '')
    case ParentRelationEnum.replyAll:
      return 'Svar alle: ' + (strippedTitle || '')
    default:
      return 'Ny e-post'
  }
}
